import { render, staticRenderFns } from "./EmployeeStatus.vue?vue&type=template&id=c2be6fe6&"
import script from "./EmployeeStatus.vue?vue&type=script&lang=js&"
export * from "./EmployeeStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports